<svg:g xmlns:svg="http://www.w3.org/2000/svg" class="stages">
    <svg:g *ngFor="let st of stages" class="stage-group"
           container="body" ngbPopover="{{st.text}}" triggers="mouseenter:mouseleave"
           popoverTitle="{{st.label}}">
        <!-- Stage name in the left gutter (currentColor → themes with the app). -->
        <svg:text [attr.x]="st.x > 0 ? labelGutter - 8 : 0" [attr.y]="st.y + st.height / 2"
                  text-anchor="end" dy="0.32em"
                  fill="currentColor" fill-opacity="0.85" font-size="11">
            {{st.displayLabel}}
            <svg:title *ngIf="st.fullLabel !== st.displayLabel">{{st.fullLabel}}</svg:title>
        </svg:text>
        <svg:rect class="rect" rx="2"
                  [attr.x]="st.x" [attr.y]="st.y"
                  [attr.width]="st.width" [attr.height]="st.height"
                  [attr.fill]="st.fill" fill-opacity="0.88"></svg:rect>
        <!-- Value centered inside the bar; conversion vs first stage in the right gutter. -->
        <svg:text *ngIf="st.displayValue"
                  [attr.x]="st.x + st.width / 2" [attr.y]="st.y + st.height / 2"
                  text-anchor="middle" dy="0.32em"
                  fill="#fff" font-size="11" font-weight="600"
                  style="pointer-events: none">{{st.displayValue}}</svg:text>
        <svg:text [attr.x]="st.x + st.width + 8" [attr.y]="st.y + st.height / 2"
                  text-anchor="start" dy="0.32em"
                  fill="currentColor" fill-opacity="0.6" font-size="10"
                  style="pointer-events: none">{{st.displayPercent}}</svg:text>
    </svg:g>
</svg:g>
